module.exports = __webpack_public_path__ + "static/image/help_center_create_ad.svg?da0f06171a46c9f551420c3419b0338e";